import './Select-919a2fa3.css';

var classes = {"Select":"prc-Select-Select-F7Flx","TextInputWrapper":"prc-Select-TextInputWrapper-eBxmL","disabled":"prc-Select-disabled-qvF9B","ArrowIndicator":"prc-Select-ArrowIndicator-vtddB"};

export { classes as default };
